(function () {
  function initPrestige(section) {
    if (!section || section.dataset.cbPrestigeReady === 'true') return;
    section.dataset.cbPrestigeReady = 'true';

    const desktop = section.querySelector('[data-prestige-desktop]');
    if (!desktop) return;

    const cards = Array.from(desktop.querySelectorAll('[data-prestige-card]'));
    if (!cards.length) return;

    const desktopOnly = window.matchMedia('(min-width: 990px)');
    if (!desktopOnly.matches) return;

    function setActiveCard(targetCard) {
      cards.forEach(function (card) {
        const isActive = card === targetCard;
        card.classList.toggle('is-active', isActive);
        card.classList.toggle('is-narrow', !isActive);
      });
    }

    cards.forEach(function (card) {
      card.addEventListener('mouseenter', function () {
        setActiveCard(card);
      });

      card.addEventListener('focus', function () {
        setActiveCard(card);
      });
    });
  }

  function bootPrestige() {
    const sections = Array.from(document.querySelectorAll('[data-cb-prestige]'));
    if (!sections.length) return;

    if (!('IntersectionObserver' in window)) {
      sections.forEach(initPrestige);
      return;
    }

    const observer = new IntersectionObserver(
      function (entries, obs) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;

          initPrestige(entry.target);
          obs.unobserve(entry.target);
        });
      },
      {
        root: null,
        rootMargin: '300px 0px',
        threshold: 0.01
      }
    );

    sections.forEach(function (section) {
      observer.observe(section);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootPrestige, { once: true });
  } else {
    bootPrestige();
  }
})();